'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemplateConfigurationSubHeader = exports.TemplateConfiguration = exports.MODE = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _containers = require('containers');

var _templates = require('redux/modules/templates');

var _TemplateConfigurationSubHeader2 = require('./TemplateConfigurationSubHeader');

var _TemplateConfigurationSubHeader3 = _interopRequireDefault(_TemplateConfigurationSubHeader2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODE = exports.MODE = {
  NEW: 'template-configuration/NEW',
  EDIT: 'template-configuration/EDIT'
};

var TemplateConfiguration = exports.TemplateConfiguration = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TemplateConfiguration, _Component);

  function TemplateConfiguration() {
    (0, _classCallCheck3.default)(this, TemplateConfiguration);
    return (0, _possibleConstructorReturn3.default)(this, (TemplateConfiguration.__proto__ || (0, _getPrototypeOf2.default)(TemplateConfiguration)).apply(this, arguments));
  }

  (0, _createClass3.default)(TemplateConfiguration, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          mode = _props.mode,
          template = _props.template,
          templateParam = _props.templateParam;

      // NEW MODE
      // TODO Review this method

      if (mode === MODE.NEW && (!template || !template.isNew)) {
        this.props.setCurrentTemplate(null, true);
      }

      // EDIT MODE
      if (mode === MODE.EDIT && (!template || String(template.id) !== String(templateParam))) {
        this.props.setCurrentTemplate(templateParam);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _props2 = this.props,
          template = _props2.template,
          templateParam = _props2.templateParam;
      var nextTemplate = nextProps.template,
          nextTemplateParam = nextProps.templateParam;

      // WARNING: Only changes if other different template is chosen.

      var differentIds = (template && template.id) !== (nextTemplate && nextTemplate.id);
      var differentParams = templateParam !== nextTemplateParam;

      return differentIds || differentParams;
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./TemplateConfiguration.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.root },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Template Creation' }),
        _react2.default.createElement(_containers.TemplateEditor, { className: styles.editor })
      );
    }
  }]);
  return TemplateConfiguration;
}(_react.Component), _class.preload = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return [[_templates.setCurrentTemplateSaga, { template: params.template, isNew: !params.template }]];
}, _class.propTypes = {
  template: _react.PropTypes.object,
  templateParam: _react.PropTypes.string,
  mode: _react.PropTypes.string,
  setCurrentTemplate: _react.PropTypes.func
}, _temp);


var mapStateToProps = function mapStateToProps(state, routing) {
  var templateParam = routing.params.template || routing.location.query.template || undefined;
  var mode = templateParam === undefined ? MODE.NEW : MODE.EDIT;
  var template = state.templateApplication.templates.currentTemplate;

  return { template: template, templateParam: templateParam, mode: mode };
};

exports.TemplateConfigurationSubHeader = _TemplateConfigurationSubHeader3.default;
exports.default = (0, _reactRedux.connect)(mapStateToProps, { setCurrentTemplate: _templates.setCurrentTemplate })(TemplateConfiguration);


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateConfiguration/TemplateConfiguration.jsx
// module id = 1643
// module chunks = 0